import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Paper, Button } from "@material-ui/core";
import t from "../../../languages/pl";

const useStyles = theme => ({
    paper: {
        margin: theme.spacing(1),
        minHeight: "5vh",
        padding: theme.spacing(1),
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    button: {
        margin: theme.spacing(1),
    },
    label: {
        color: "#FFF"
    }
});

const ControlsBar = props => {
    const { classes, onReportOrder, onTemplateShow } = props;

    return (
        <Paper
            square
            className={classes.paper}
        >
            <Button
                variant="contained"
                color="secondary"
                classes={{root: classes.button}}
                onClick={onTemplateShow}
            >
                {t.importTemplate}
            </Button>
            <Button
                variant="contained"
                color="primary"
                classes={{root: classes.button, label: classes.label}}
                onClick={onReportOrder}
            >
                {t.orderReport}
            </Button>
        </Paper>
    );
};

ControlsBar.propTypes = {
    classes: PropTypes.object,
    onReportOrder: PropTypes.func,
    onTemplateShow: PropTypes.func
};

export default withStyles(useStyles)(ControlsBar);
